import ApiRequest from '../request'

export default class Contracts {
  constructor() {
    this.apiRequest = new ApiRequest()
  }
  async getListReferences(ref, params) {
    try {
      const res = await this.apiRequest.get(`${ref}`, params)
      return res
    } catch (error) {
      return error.response
    }
  }
}
